<template>
  <section id="hero" data-component="hero">
    <LazyBg :src="bgSrc" eager />
    <div class="hero-overlay" />
    <div class="hero-content">
      <div class="hero-badge">
        算力服务
      </div>
      <h1 class="display-xl hero-title">
        全栈式云算力服务<br /><span class="gradient-text">五大区域，极速交付</span>
      </h1>
      <p class="hero-subtitle">
        覆盖华北、华东、华中、华南、西南、西北、东北七大区域算力中心，依托全域规划节点与分布式集群架构，实现软硬件一体化快速交付，配套全流程闭环运维管控，提供从机房建设到运营管理的端到端一体化服务。
      </p>
      <div class="hero-actions">
        <RouterLink :to="{ path: '/', hash: '#cta-contact' }" class="btn-primary">
          获取算力方案报价
          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </RouterLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import bgSrc from '@/assets/AIservices_bg1.jpg';
import LazyBg from '@/components/LazyBg.vue';
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import { useHeroCanvas } from '@/composables/useHeroCanvas';
import '@/styles/newhome/home/hero.css';

const canvasEl = ref<HTMLCanvasElement | null>(null);
useHeroCanvas(canvasEl);
</script>
<style scoped lang="scss">
 #hero {
  /* bg via LazyBg */
}
</style>